import { Component } from "react";
import { connect } from "react-redux";
import { Table, Card, message, Modal } from "antd";
import PropTypes from "prop-types";
import { usrRole } from "../../utils/dataUtil";
import {
  req_del_pim_staff_overtime_offset,
  req_add_pim_staff_overtime_offset,
  req_list_pim_staff_overtime_offset,
} from "../../api";
class OvertimeOffsetSelfModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };

  state = {
    item: {},
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    searchField: "None",
    searchValue: "",
    setOffsetType: "TIME",
    setOffsetMinutes: 0,
    setRecordDescription: "",
  };

  componentDidMount() {
    this.api_item_list();
  }

  ////////////////////////////////////////////////////////////
  api_item_list = async () => {
    //console.log( this.props.data)
    const { searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    const { StaffCode, OverTimeMonth } = this.props.data;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true });
    const result = await req_list_pim_staff_overtime_offset(
      userLevel,
      userCode,
      OverTimeMonth,
      StaffCode,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({
        data: items,
        loading: false,
      });
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  api_add_item = async () => {
    const { setOffsetType, setOffsetMinutes, setRecordDescription } =
      this.state;
    const { StaffCode, OverTimeMonth } = this.props.data;
    const { token } = this.props.user;
    const item = {
      StaffCode: StaffCode,
      YearMonth: OverTimeMonth,
      OffsetType: setOffsetType,
      OffsetMinutes: setOffsetMinutes,
      RecordDescription: setRecordDescription,
    };
    const result = await req_add_pim_staff_overtime_offset(item, token);
    if (result.status === "success") {
      message.success(result.message);
      this.api_item_list();
    } else {
      this.setState({ loading: false });
      message.error(result.message);
    }
  };

  api_detete_item = async (item) => {
    const { Uid } = item;
    const { token } = this.props.user;

    const result = await req_del_pim_staff_overtime_offset(Uid, token);
    if (result.status === "success") {
      message.success(result.message);
      this.api_item_list();
    } else {
      message.error(result.message);
    }
  };

  ///////////////////////////////////////////////////////////
  onFinish = async (values) => {
    //console.log("data:", values);
    this.setState({ loading: true });
    this.setState({ setOffsetMinutes: values.setOffsetMinutes });
    await this.api_add_item();
  };

  ///////////////////////////////////////////////////////////
  handleSelectChange = (value) => {
    this.setState({ setOffsetType: value });
  };

  handleTextAreaChange = (e) => {
    console.log(e.target.value);
    this.setState({ setRecordDescription: e.target.value });
  };

  handle_btn_event = (type, item) => {
    switch (type) {
      case "delete":
        const { Uid } = item;
        Modal.confirm({
          title: `您確定註銷此筆資料嗎?`,
          onOk: () => {
            console.log(item);
            const row = {
              Uid: Uid,
            };
            this.api_detete_item(row);
          },
        });
        break;
      default:
        return;
    }
  };

  render() {
    const { data, loading} = this.state;
    const columns = [
      {
        title: "抵銷方式",
        width: 80,
        dataIndex: "OffsetType",
        key: "OffsetType",
        render: (text) => <>{text === "TIME" ? "補休" : "經費"}</>,
      },
      {
        title: "抵銷分鐘",
        width: 80,
        dataIndex: "OffsetMinutes",
        key: "OffsetMinutes",
      },
      {
        title: "抵銷說明",
        width: 100,
        dataIndex: "RecordDescription",
        key: "RecordDescription",
      },
    ];
    const title = (
      <>
        抵扣年月：{this.props.data.OverTimeMonth} | 姓名：
        {this.props.data.StaffName}
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
          scroll={{
            y: 55 * 5,
          }}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(OvertimeOffsetSelfModal);
